import React from "react";

type Props = {
  description?: string;
  directionalHint?: any;
  ariaLabel?: string;
  // Circle size in px
  size?: number;
  // Optional external className for the icon trigger
  className?: string;
};

const FieldDescriptionCallout: React.FC<Props> = ({
  description,
  directionalHint,
  ariaLabel = "Field information",
  size = 14,
  className,
}) => {
  const ref = React.useRef<HTMLSpanElement | null>(null);
  const [open, setOpen] = React.useState(false);

  if (!description) return null;

  const wrapperStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    marginLeft: 8,
  };

  const circle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    borderRadius: "50%",
    background: "hsl(var(--primary))",
    border: "1px solid transparent",
    color: "#FFF",
    cursor: "help",
    fontSize: Math.max(10, Math.round(size * 0.7)),
    lineHeight: `${size}px`,
  };

  const calloutStyle: React.CSSProperties = {
    position: "absolute",
    bottom: "140%",
    left: "50%",
    zIndex: 1000,
    minWidth: 320,
    padding: 12,
    fontSize: 12,
    color: "#FFF",
    borderRadius: 8,
    background: "hsl(var(--primary))",
    boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
  };

  return (
    <span
      ref={ref}
      tabIndex={0}
      role="button"
      aria-label={ariaLabel}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={wrapperStyle}
      className={className}
    >
      <span style={circle}>i</span>
      {open && (
        <div style={calloutStyle} role="tooltip">
          {description}
        </div>
      )}
    </span>
  );
};

export default FieldDescriptionCallout;
